/**
 * Property reclassification (U6 loop) — RO-2-03 conversion of
 * `excellent/src/properties/actions.ts` (`reclassifyUnattributedAction`).
 *
 * Pins one unattributed leaf-fact row to a property. Delegates to core's
 * `reclassifyProperty` — the same authority the `property_reclassify` MCP
 * tool calls for agents. `table` is re-validated against core's
 * `ATTRIBUTABLE_TABLES` inside `reclassifyProperty` (the only safe gate for
 * the raw identifier), and both the property and the row are workspace-scoped
 * there.
 */

import { z } from "zod";
import type { Operation } from "../../types";

export const propertiesReclassifyBody = z.object({
  table: z.string().min(1),
  rowId: z.number().int(),
  projectUid: z.string().min(1),
});
export type PropertiesReclassifyBody = z.infer<typeof propertiesReclassifyBody>;

export const propertiesReclassifyResponse = z.object({
  ok: z.boolean(),
  reason: z.string().optional(),
});
export type PropertiesReclassifyResponse = z.infer<typeof propertiesReclassifyResponse>;

export const propertiesReclassify: Operation<
  void,
  void,
  z.infer<typeof propertiesReclassifyBody>,
  z.infer<typeof propertiesReclassifyResponse>
> = {
  method: "POST",
  path: () => "/api/database/properties/reclassify",
  body: propertiesReclassifyBody,
  response: propertiesReclassifyResponse,
};

export const properties = {
  reclassify: propertiesReclassify,
};
